import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';

type SyncEhrAppointmentsByProviderPayload = {
  org_uuid: string;
  ehr: string;
  provider_ehr_id: string | number;
};

type SyncEhrAppointmentsByProviderResponse = {
  message: string;
  queue: string;
  provider_ehr_id: string | number;
};

export const useSyncEhrAppointmentsByProvider = (
  options?: UseMutationOptions<
    SyncEhrAppointmentsByProviderResponse,
    unknown,
    SyncEhrAppointmentsByProviderPayload
  >
) => {
  return useMutation<
    SyncEhrAppointmentsByProviderResponse,
    unknown,
    SyncEhrAppointmentsByProviderPayload
  >({
    mutationFn: (payload) =>
      integrationsApi
        .post('/ehr/sync-appointments-by-provider', payload)
        .then((res) => res.data),
    ...options,
  });
};
